import { Autocomplete, Box, TextField } from "@mui/material";
import type { RollNameOption } from "../models/RollTurnHistoryDetail";

interface Props {
	rollName: string | null;
	options: RollNameOption[];
	loadingOptions: boolean;
	onRollNameChange: (rollName: string | null) => void;
}

export const RollTurnHistoryToolbar = ({
	rollName,
	options,
	loadingOptions,
	onRollNameChange,
}: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 1,
			px: 1.5,
			py: 0.75,
			flexWrap: "wrap",
		}}
	>
		<Box sx={{ minWidth: 220, maxWidth: 260 }}>
			<Autocomplete
				options={options}
				getOptionLabel={(option) => option.Name}
				isOptionEqualToValue={(option, value) => option.Name === value.Name}
				value={options.find((o) => o.Name === rollName) ?? null}
				onChange={(_, option) => onRollNameChange(option?.Name ?? null)}
				loading={loadingOptions}
				size="small"
				fullWidth
				autoHighlight
				renderInput={(params) => (
					<TextField
						{...params}
						label="Roll"
						placeholder="Specify foundry number"
					/>
				)}
			/>
		</Box>
	</Box>
);
